// #644 — "1st", "2nd", "3rd", "4th"... for a placing. English ordinal suffix
// rules: 11/12/13 are always "th" (the 1st/2nd/3rd exceptions only apply to the
// LAST digit when the number doesn't end in 11-13).
export function formatOrdinal(n) {
  const value = Number(n);
  if (!Number.isFinite(value) || value <= 0) return "";
  const mod100 = value % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${value}th`;
  switch (value % 10) {
    case 1:
      return `${value}st`;
    case 2:
      return `${value}nd`;
    case 3:
      return `${value}rd`;
    default:
      return `${value}th`;
  }
}

export default formatOrdinal;
